module.exports = __webpack_public_path__ + "img/chess-pawn-piece.0b4fc3bd.svg";